export default `---
slug: linear-optimization
title: "Linear Optimization"
year: 2018
category: university
featured: false
tags: [AMPL, Operations Research, Optimization]
thumbnail: /images/projects/1_thumb.jpg
description: "Solving linear optimization problems with AMPL for the Fundamentals of Operations Research course at Politecnico di Milano."
relatedLinks: []
---
![linear optimization](/images/projects/1_thumb.jpg)

For the class "Fundamentals of Operations Research" in Politecnico of Milan, we had to solve linear optimization problems.

To do so, we formalized the problems according to the Operations Research best practices.

Then, we created scripts in AMPL and run them to obtain the problems solutions.
`;
